import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorMessageComponent } from '../error-message/error-message.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProfileService } from 'src/app/core/services/profile.service';
import { SuccessMessageComponent } from '../success-message/success-message.component';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { TokenDeclinedComponent } from '../token-declined/token-declined.component';
import { AddTokensComponent } from '../../wallet/add-tokens/add-tokens.component';
import { WalletService } from 'src/app/core/services/wallet.service';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss']
})
export class SubscribeComponent implements OnInit {

  @Input() currentuser;
  @Input() upgrade;
  availableTokens;
  contentLoader = true;
  constructor(
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _profileService: ProfileService,
    private modalService: NgbModal,
    private _walletService: WalletService
  ) { }

  ngOnInit() {
    this.loadTokens(); this.getLibraryPrice()

  }
  closeDialog() {
    this.activeModal.close();
  }

  getLibraryPrice() {
    // this.spinner.show();
    this._profileService.getUserLibraryPrice(this.currentuser.id).subscribe((response) => {
      // this.spinner.hide();
      this.contentLoader = false;
      if (response.success) {
        this.currentuser.library_price = response.data.library_price;
        this.currentuser.verification_rejected = response.data.verification_rejected;
        if (this.currentuser.verification_rejected) {
          const modal = document.querySelector('.modal.show .modal-dialog');
          if (modal) {
            modal.classList.remove('modal-lg');
          }
        } else {
          if (!this.upgrade && response.data.library_price > 0) {
            const modal = document.querySelector('.modal.show .modal-dialog');
            if (modal && !modal.classList.contains('modal-lg')) {
              modal.classList.add('modal-lg');
            }
          }
        }
      }
    },(error)=>{
      this.contentLoader = false;
    });
  }
  loadTokens() {
    this.spinner.show();
    this._walletService.loadTokens().subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success && response.data.account) {
          this.availableTokens = response.data.account.total_tokens
        }
      }, (error: any) => {
        this.spinner.hide();
      });
  }

  premiumSubscribe(premium) {
    console.log("first time ");


    if (this.upgrade) {
      this.upgradeToPremium();
      return;
    }
    let params = {
      'recipient_id': this.currentuser.id
    }
    if (premium) {
      params['premium_package'] = true;
    }
    this.contentLoader = true;
    this._profileService.profileSubscribe(params).subscribe((response) => {
      this.contentLoader = false;
      console.log(response.data," first time response.data");

      if (response.success) {
        if (premium) {
          response.data.subscriber.paid_subscriber = true;
        }
        this.activeModal.close(response.data.subscriber);
        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        if (response.data.subscriber.status == 'pending') {
          modalRef.componentInstance.title = ((premium) ? "Subscription" : "Subscribing") + " Request sent!";
          modalRef.componentInstance.message = "You have successfully sent " + ((premium) ? "Subscription" : "Subscribing") + " request to " + ((this.currentuser.business_profile && this.currentuser.business_profile[0].name) ? this.currentuser.business_profile[0].name : this.currentuser.name);
        } else {
          modalRef.componentInstance.title = "Subscribed Successfully!";
          modalRef.componentInstance.message = "You have successfully subscribed to " + this.currentuser.business_name + ((premium) ? "'s  paid subscription pack." : "");
        }
      }
      else if (response.errors == "You don't have enough token to subscribe premium library.") {
        const modalRef = this.modalService.open(TokenDeclinedComponent, { centered: true });
        modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.SORRY_YOU_CANT_PURCHASE_PACK;
        modalRef.componentInstance.closeOnSave = true;
        modalRef.result.then((response) => {
          if (response) {
            this.addTokens();
          }
        });
      }
      else if (!response.success) {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = response.errors;
      }
    });
  }

  upgradeToPremium() {
    this.contentLoader = true;
    this._profileService.upgradeSubscription(this.currentuser.subscriber_request_details.sender.subscriber_id).subscribe((response) => {
      this.contentLoader = false;
      if (response.success) {
        response.data.subscriber.paid_subscriber = true;
        this.activeModal.close(response.data.subscriber);
        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modalRef.componentInstance.title = "Subscription upgraded Successfully!";
        modalRef.componentInstance.message = "You have successfully upgraded to " + ((this.currentuser.business_profile && this.currentuser.business_profile[0].name) ? this.currentuser.business_profile[0].name : this.currentuser.name) + "'s paid subscription pack.";
      }
      else if (response.errors == "You don't have enough token to upgrade premium library.") {
        const modalRef = this.modalService.open(TokenDeclinedComponent, { centered: true });
        modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.SORRY_YOU_CANT_PURCHASE_PACK;
        modalRef.componentInstance.closeOnSave = true;
        modalRef.result.then((response) => {
          if (response) {
            this.addTokens();
          }
        });
      }
      else if (!response.success) {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = response.errors;
      }
    });
  }

  addTokens() {
    const modalRef = this.modalService.open(AddTokensComponent, { size: 'lg', centered: true, windowClass: 'add-token' });
    modalRef.componentInstance.sourceCart = 'subscriptionModal';
    modalRef.componentInstance.userId = this.currentuser.id;
    modalRef.componentInstance.inputTokens = (this.currentuser.library_price > this.availableTokens) ? Math.ceil(this.currentuser.library_price - this.availableTokens) : 0;
  }

}
